import { render, staticRenderFns } from "./ReceteStokPriceCellRenderer.vue?vue&type=template&id=ab08566a"
import script from "./ReceteStokPriceCellRenderer.vue?vue&type=script&lang=js"
export * from "./ReceteStokPriceCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports